module.exports = __webpack_public_path__ + "img/toyota-highlander.4015ef14.jpg";